import vars from "vars"

class Fns {
  constructor() {
  }

  sizer() {
    var h = $(window).height();
    // var ih = window.innerHeight;
    // var oh = window.outerHeight;
    var w = $(window).width();
    var ratio = w / h;
    // var headerH = $(".l-header").height();
    // var footerH = $(".l-footer").height();
    // var contH = ih - (headerH + footerH);
    // var contH2 = h - 100;

    $(".js-height").height(h);

    $(".js-ck-youtube iframe").each(function(){
      var mov_ratio = "0.56";
      var mov_w = $(this).width();
      $(this).attr("height", mov_w * mov_ratio);
    });

    // 高さのないモニタ対策
    if( h < 768 ){
      $("html").addClass("height-low");
      $("html").removeClass("height-normal");
    } else{
      $("html").removeClass("height-low");
      $("html").addClass("height-normal");
    }

    if( ratio > 1 ) {
      $("html").removeClass("orient-v");
      $("html").addClass("orient-h");
    } else{
      $("html").removeClass("orient-h");
      $("html").addClass("orient-v");
    }
  }

  touchHover() {
    var hoverTarget = "a, button, li, p, article, .js-link";
    $(document).on("touchstart", hoverTarget,  function() {
      $(this).attr("data-hover", "touch");
    });
    $(document).on("touchend", hoverTarget, function() {
      $(this).removeAttr("data-hover");
    });
  }

  breakPoint() {
    var w = window.innerWidth;
    var breakSP = 787;

    if(w > breakSP){
      $("html").attr("data-mode", "pc");
    } else{
      $("html").attr("data-mode", "sp");
    }

    if(w < breakSP){
      $("html").addClass("width-sp");
      $("html").removeClass("width-pc");
    } else{
      $("html").removeClass("width-sp");
      $("html").addClass("width-pc");
    }
  }

  uaCheck() {

    if( $("html").is(vars.uaset.sp) ){
      $("html").addClass("ua-sp");
    } else {
      $("html").addClass("ua-pc");
    }
  }

  exLink() {
    // 外部リンクはblankに
    var md = $(".layout__cont");
    $("a[href^='http']", md).each(function(){
      var $t = $(this);
      var href = $(this).attr("href");
      var host = location.hostname;

      if(! href.has(host) ){
        $t.attr("target", "_blank");
      }
    });
  }

  topPositions() {
    var scTop = $(window).scrollTop();

    $(".top-anchor-link a").each(function(){
      var self = $(this);
      var href = self.attr("href");
      var sec = $(href);

      if( sec.offset().top - 50 <= scTop ) {
        self.addClass("is-scrolled")
      } else{
        self.removeClass("is-scrolled")
      }

      $(".top-anchor-link a").removeClass("is-active");
      $(".top-anchor-link .is-scrolled:last").addClass("is-active");
    })
  }
}

const fns = new Fns()
export default fns



// WEBPACK FOOTER //
// ./_src/js/util/functions.js